(() => {
  function init(root) {
    const bar = root?.querySelector('[data-product-light-toolbar]');
    const img = root?.querySelector('.bp-media:first-child [data-collection-off]');
    if (!bar || !img || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const toggle = bar.querySelector('[data-product-light-switch]');
    const label = bar.querySelector('[data-product-light-label]');
    const status = bar.querySelector('[role=status]');
    const first = root.querySelector('.bp-media:first-child');
    const zoom = first.querySelector('[data-bp-zoom]');
    let originalZoom = zoom?.dataset.bpZoom;
    const variantData = root.querySelector('[data-elio-light-variants]');
    const variantImages = variantData ? JSON.parse(variantData.textContent) : null;
    const hero = first.querySelector('img:not([data-collection-off])');
    let variantRequest = 0;
    let on = true, ready;
    function prepare() {
      if (!ready) {
        img.src = img.dataset.collectionOff.replace('width=720', 'width=1100');
        ready = img.decode().catch(error => { ready = null; throw error; });
      }
      return ready;
    }
    function update() {
      root.dataset.productLights = on ? 'on' : 'off';
      toggle.setAttribute('aria-checked', String(on));
      label.textContent = on ? 'Lights on' : 'Lights off';
      if (zoom) zoom.dataset.bpZoom = on ? originalZoom : img.src;
    }
    async function updateVariant() {
      if (!variantImages || !hero) return;
      const selected = root.querySelector('.bp-form [name="id"]:checked, .bp-form input[type="hidden"][name="id"]');
      const pair = variantImages[selected?.value];
      if (!pair) return;
      const request = ++variantRequest;
      hero.removeAttribute('srcset');
      hero.src = pair.on;
      hero.alt = pair.alt;
      originalZoom = pair.on;
      img.dataset.collectionOff = pair.off;
      img.removeAttribute('src');
      ready = null;
      if (!on) {
        toggle.disabled = true;
        status.textContent = '';
        try { await prepare(); }
        catch { if (request === variantRequest) { on = true; status.textContent = 'The preview could not load. Please try again.'; } }
        finally { if (request === variantRequest) toggle.disabled = false; }
      }
      if (request !== variantRequest) return;
      update();
      root.querySelector('.bp-gallery')?.scrollTo({ left: 0, behavior: 'instant' });
    }
    if (variantImages) {
      root.querySelector('.bp-form')?.addEventListener('change', event => {
        if (event.target.name === 'id') updateVariant();
      });
      updateVariant();
    }
    update();
    bar.hidden = false;
    toggle.addEventListener('pointerenter', () => prepare().catch(() => {}));
    toggle.addEventListener('focus', () => prepare().catch(() => {}));
    toggle.addEventListener('click', async () => {
      toggle.disabled = true;
      status.textContent = '';
      try {
        if (on) { label.textContent = 'Switching off…'; await prepare(); }
        on = !on;
        update();
        const gallery = root.querySelector('.bp-gallery');
        gallery.scrollTo({ left: 0, behavior: 'instant' });
        const bounds = first.getBoundingClientRect();
        const barBottom = bar.getBoundingClientRect().bottom;
        if (bounds.bottom <= barBottom || bounds.top >= window.innerHeight) {
          first.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      } catch { status.textContent = 'The preview could not load. Please try again.'; }
      finally { update(); toggle.disabled = false; }
    });
  }
  document.querySelectorAll('[data-belluce-product]').forEach(init);
  document.addEventListener('maison:product:loaded', e => init(e.detail.root));
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-belluce-product]').forEach(init));
})();
